const defaultLogger = console;
export { defaultLogger };